import logo from 'assets/logo.jpg';
import { useEffect, useState } from 'react';
import { ButtonGroup, Image } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-scroll';

import { Arrow } from 'assets/SVG';
import { menuItems } from '../components/MenuItems';

function Header() {
    const [expanded, setExpanded] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const [activeLink, setActiveLink] = useState("Home");


    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);



    return (
        <>
            <Navbar
                expanded={expanded}
                expand="lg"
                className={`p-0  py-2 border-bottom w-100 top-0 bg-white ${isSticky ? 'position-sticky shadow-sm' : ''}`}
                style={{ zIndex: 1030, backgroundColor: "#F2F0F8" }}
            >   
                <Container>
                    <Link to="Home"
                        duration={1000}
                        className={`pointer  pb-0   border-0`}
                        onSetActive={() => setActiveLink("Home")}
                    >
                        <Navbar.Brand className=""  >
                            <Image src={logo} alt="Logo" fluid className='logo headerLogo'  />
                        </Navbar.Brand>
                    </Link>
                    <Navbar.Toggle
                        className="border-0"
                        aria-controls="navbarScroll"
                        onClick={() => setExpanded(!expanded)}
                    >
                        {expanded ? <FaTimes color='var(--color1)' /> : <FaBars color='var(--color1)' />}
                    </Navbar.Toggle>
                    <Navbar.Collapse className="pb-lg-0 pb-2">
                        <Nav className="mx-auto gap-lg-4">
                            {menuItems?.map((tab) => (
                                <Link
                                    key={tab?.label}
                                    to={tab?.path}
                                    duration={1000}
                                    className={`nav-link pointer ${activeLink === tab?.path ? 'active' : ''}`}
                                    onSetActive={() => setActiveLink(tab?.path)}
                                    onClick={() => setExpanded(false)}
                                >
                                    {tab?.label}
                                </Link>
                            ))}
                        </Nav>
                        <ButtonGroup className="d-flex btn-group">
            <Link
                to="Connect"  // Matches the "name" in the Element
                smooth={true}  // Smooth scrolling effect
                duration={500} // Duration of the scroll (in milliseconds)
            >
                <Button
                    className="btn-custom-outline"
                    style={{ padding: "5px 30px" }}
                >
                    <span className="text-black">
                        Contact us
                    </span>
                </Button>
            </Link>
        </ButtonGroup>

                    </Navbar.Collapse>
                </Container>
            </Navbar>


        </>
    );
}

export default Header;
